var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUseATemplateActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    rx: 4,
    fill: "#DAF9F9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2504_4602)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.6607 9.26242L17.2403 10.2162M12.8933 12.1101L14.6831 12.5869M12.9824 17.4748L13.6983 17.6656C15.7232 18.2051 16.7358 18.4749 17.5334 18.017C18.331 17.559 18.6023 16.5522 19.1449 14.5387L19.9122 11.6911C20.4548 9.67754 20.7261 8.67076 20.2656 7.87762C19.8051 7.08448 18.7926 6.81471 16.7676 6.27518L16.0517 6.08443C14.0267 5.54489 13.0142 5.27513 12.2166 5.73305C11.419 6.19097 11.1477 7.19775 10.6051 9.21131L9.83774 12.0589C9.29515 14.0724 9.02386 15.0792 9.48437 15.8723C9.94489 16.6655 10.9574 16.9353 12.9824 17.4748Z",
    stroke: "#003E3E",
    strokeWidth: 1.125,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 19.7097L12.2858 19.9042C10.2655 20.4543 9.25542 20.7294 8.45964 20.2625C7.66388 19.7956 7.39322 18.7691 6.8519 16.716L6.08637 13.8126C5.54505 11.7595 5.27439 10.733 5.73383 9.92427C6.13125 9.22472 7 9.25019 8.125 9.2501",
    stroke: "#003E3E",
    strokeWidth: 1.125,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2504_4602"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUseATemplateActive);
export default __webpack_public_path__ + "static/media/Use_a_template_active.01421c8dd433b728843dcf2dad59e843.svg";
export { ForwardRef as ReactComponent };